IREP.MobileAdvert = (function () {


    var init = function () {
        //Don't show both the disclaimer and the slide-in at the same time. 
        if ($("#storeDisclaimer").is(':visible')) { return; } //Don't show the slide-in or pop-in if the disclaimer is visible. That takes a lot of time.
        if ($("#dvMobilePopin").length == 0 && $("#dvMobileSlideinOverlay").length == 0) { return; } //If the object isn't rendered, don't waste time on the script.
        handleMobileSplash();
    }

    var handleMobileSplash = function () {
        IREP.callApi({ type: "GET", url: '/tracker', data: { code: "mobile", type: "closeMobilePopup", label: "", value: "", data: "" } }).done(function (data) {
            if (data.hits != 0) return;

            var showMobile = false;

            //Separate these out 
            if (navigator.userAgent.match(/iPhone/i) != null) {
                if (window.innerHeight >= 1000) {
                    viewportSizeFix();
                }

                $("#dvMobilePopin").show();
                $(".imgWindowsLogo").hide();
                $(".imgIosLogo").show();
                $(".imgAndroidLogo").hide();
                $(".dvDownloadAppButton").attr('href', 'itms-apps://itunes.apple.com/us/app/intel-retail-edge-program/id787231790?mt=8&uo=6&at=&ct=');

                showMobile = true;
            } else 
            if (navigator.userAgent.match(/Android/i) != null) {
                $("#dvMobilePopin").show();
                $(".imgWindowsLogo").hide();
                $(".imgIosLogo").hide();
                $(".imgAndroidLogo").show();
                $(".dvDownloadAppButton").attr('href', 'https://play.google.com/store/apps/details?id=com.phonegap.IREPMobile');

                showMobile = true;
            } else if (navigator.userAgent.match(/Windows Phone/i) != null) {
                $("#dvMobilePopin").show();
                $(".imgWindowsLogo").show();
                $(".imgIosLogo").hide();
                $(".imgAndroidLogo").hide();
                $(".dvDownloadAppButton").attr('href', 'ms-windows-store:navigate?appid=91901463-f280-4426-a609-319df352b3b4');

                /* Windows phone viewport doesn't change. Lets just increase the size of everything else and move on */
                viewportSizeFix();
                /* End ugly windows phone hack. Feel free to replace this with the 'proper' way to do viewports if you have a better solution. */

                showMobile = true;
            }

            if (showMobile) {
                var viewport = document.querySelector("meta[name=viewport]");
                viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');

                $("#dvCloseButton").on('click', function () {
                    closePopup();
                });
                $(".dvDownloadAppButton").on('click', function () {
                    IREP.track("mobile", "downloadMobileApp", $(".dvDownloadAppButton").attr('href'), '', '');
                    closePopup();
                });
            }
            else {
                //Show desktop slide-in
                IREP.callApi({ type: "GET", url: '/tracker', data: { code: "mobile", type: "closeMobileSlideIn", label: "", value: "", data: "" } }).done(function (data) {
                    if (data.hits == 0) {
                        $("#dvMobileSlideinOverlay").show();
                        $("#dvMobileSlidein").animate({ 'left': '200px' }, 1500);

                        $(".dvLearnMoreBtn").on('click', function () {
                            IREP.track("mobile", "closeMobileSlideIn", '', '', '');
                        });

                        $("#dvSlideInClose").on('click', function () {
                            $("#dvMobileSlideinOverlay").fadeOut(300);
                            IREP.track("mobile", "closeMobileSlideIn", '', '', '');
                        });
                    }
                });
            }

        });
    };

    var viewportSizeFix = function () {
        $(".dvDownloadInstructions").css('font-size', '4em');
        $(".dvDownloadInstructions").css('line-height', '2em');
        $(".dvDownloadInstructions").css('padding-top', '75px');
        $(".dvDownloadInstructions").css('padding-bottom', '50px');
        $(".imgWindowsLogo").css('width', '150px');
        $(".imgWindowsLogo").css('padding-bottom', '50px');
        $(".imgIosLogo").css('width', '150px');
        $(".imgIosLogo").css('padding-bottom', '50px');
        $(".dvDownloadAppButton").css('font-size', '4em');
        $(".dvDownloadAppButton").css('line-height', '2em');
        $(".dvDownloadAppButton").css('height', '120px');
        $("#dvCloseButton").css('font-size', '120px');
        $("#dvCloseButton").css('line-height', '160px');
        $(".logo").css('background-size', '90%');

    };

    var closePopup = function () {
        $("#dvMobilePopin").hide();
        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=1200');
        IREP.track("mobile", "closeMobilePopup", $(".dvDownloadAppButton").attr('href'), '', '');
    };

    return {
        init: init
    };
})();